<template>
    <div class="form-container" v-show="finishLoading && startAnimitionShapeOne">
        <!-- Main Form Container -->
        <div class="form-box" ref="formBox" :class="{ 'form-appear': showFormAppear }">
            <!-- Target Website Section -->
            <div class="section"
                :class="{ 'section-active': currentAnimationStep >= 1, 'section-scroll-in': currentAnimationStep === 1 }">
                <h3 class="section-title">الموقع الهدف</h3>
                <div class="input-container" ref="inputContainer">
                    <!-- Click Effect Circles -->
                    <div class="click-effect" :class="{ 'active': showClickEffect }">
                        <div class="click-circle circle-1"></div>
                        <div class="click-circle circle-2"></div>
                    </div>

                    <div class="typing-container">
                        <span class="typing-text">{{ displayText }}</span>
                        <span class="cursor" :class="{ 'blink': isTyping, 'hide': !isTyping }">|</span>
                    </div>
                </div>
            </div>

            <!-- Number of Participants Section -->
            <div class="section"
                :class="{ 'section-active': currentAnimationStep >= 2, 'section-scroll-in': currentAnimationStep === 2 }">
                <h3 class="section-title ">عدد المشاركين المحددين</h3>
                <div class="slider-container">
                    <div class="slider-track">
                        <div class="slider-fill" :style="{ width: `${selectedCheckboxes.length * 10}%` }"></div>
                    </div>
                    <span class="slider-value">{{ selectedCheckboxes.length }}</span>
                </div>
            </div>

            <!-- Participants Specialization Section -->
            <div class="section"
                :class="{ 'section-active': currentAnimationStep >= 3, 'section-scroll-in': currentAnimationStep === 3 }">
                <h3 class="section-title">تخصص المشاركين</h3>
                <div class="specialization-grid">
                    <!-- Left Column -->
                    <div class="specialization-column">
                        <div class="checkbox-item">
                            <input  aria-hidden="true" tabindex="-1"  type="checkbox" id="ui-design" class="checkbox"
                                :checked="selectedCheckboxes.includes('ui-design')">
                            <label for="ui-design">تصميم واجهة المستخدم</label>
                            <!-- Click Effect for UI Design -->
                            <div class="checkbox-click-effect"
                                :class="{ 'active': selectedCheckboxes.includes('ui-design') }">
                                <div class="click-circle circle-1"></div>
                                <div class="click-circle circle-2"></div>
                            </div>
                        </div>
                        <div class="checkbox-item">
                            <input   aria-hidden="true" tabindex="-1"  type="checkbox" id="digital-exp" class="checkbox">
                            <label for="digital-exp">التجربة الرقمية</label>
                        </div>
                        <div class="checkbox-item">
                            <input aria-hidden="true" tabindex="-1"  type="checkbox" id="accessibility" class="checkbox"
                                :checked="selectedCheckboxes.includes('accessibility')">
                            <label for="accessibility">سهولة الوصول</label>
                            <!-- Click Effect for Accessibility -->
                            <div class="checkbox-click-effect"
                                :class="{ 'active': selectedCheckboxes.includes('accessibility') }">
                                <div class="click-circle circle-1"></div>
                                <div class="click-circle circle-2"></div>
                            </div>
                        </div>
                        <div class="checkbox-item">
                            <input aria-hidden="true" tabindex="-1"  type="checkbox" id="seo" class="checkbox"
                                :checked="selectedCheckboxes.includes('seo')">
                            <label for="seo">تحسين SEO</label>
                            <!-- Click Effect for SEO -->
                            <div class="checkbox-click-effect"
                                :class="{ 'active': selectedCheckboxes.includes('seo') }">
                                <div class="click-circle circle-1"></div>
                                <div class="click-circle circle-2"></div>
                            </div>
                        </div>
                    </div>
                    <!-- Right Column -->
                    <div class="specialization-column">
                        <div class="checkbox-item">
                            <input aria-hidden="true" tabindex="-1"  type="checkbox" id="ux" class="checkbox"
                                :checked="selectedCheckboxes.includes('ux')">
                            <label for="ux">تجربة مستخدم</label>
                            <!-- Click Effect for UX -->
                            <div class="checkbox-click-effect" :class="{ 'active': selectedCheckboxes.includes('ux') }">
                                <div class="click-circle circle-1"></div>
                                <div class="click-circle circle-2"></div>
                            </div>
                        </div>
                        <div class="checkbox-item">
                            <input aria-hidden="true" tabindex="-1"  type="checkbox" id="languages" class="checkbox">
                            <label for="languages">دعم لغات وترجمة</label>
                        </div>
                        <div class="checkbox-item">
                            <input aria-hidden="true" tabindex="-1"  type="checkbox" id="content" class="checkbox">
                            <label for="content">كتابة المحتوى</label>
                        </div>
                        <div class="checkbox-item">
                            <input aria-hidden="true" tabindex="-1"  type="checkbox" id="security" class="checkbox">
                            <label for="security">أمن سيبراني</label>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Maximum Evaluations Section -->
            <div class="section"
                :class="{ 'section-active': currentAnimationStep >= 4, 'section-scroll-in': currentAnimationStep === 4 }">
                <h3 class="section-title">حدد اقصى عدد للتقيمات لكل مشارك</h3>
                <div class="slider-container" ref="secondSliderContainer">
                    <!-- Click Effect for Second Slider -->
                    <div class="slider-click-effect" :class="{ 'active': showSecondSliderClickEffect }">
                        <div class="click-circle circle-1"></div>
                        <div class="click-circle circle-2"></div>
                    </div>

                    <div class="slider-track">
                        <div class="slider-fill" :style="{ width: `${secondSliderFillWidth}%` }"
                            :class="{ 'animate': showSecondSliderAnimation }"></div>
                    </div>
                    <span class="slider-value">{{ secondSliderValue }}</span>
                </div>
            </div>

            <!-- Test Screen Size Section -->
            <div class="section"
                :class="{ 'section-active': currentAnimationStep >= 5, 'section-scroll-in': currentAnimationStep === 5 }">
                <h3 class="section-title">حجم شاشات الاختبار</h3>
                <div class="screen-size-options" ref="screenSizeContainer">
                    <!-- Click Effect for Screen Size -->
                    <div class="screen-click-effect" :class="{ 'active': showScreenSizeClickEffect }">
                        <div class="click-circle circle-1"></div>
                        <div class="click-circle circle-2"></div>
                    </div>

                    <div class="checkbox-item">
                        <input aria-hidden="true" tabindex="-1"  type="checkbox" id="computer" class="checkbox"
                            :checked="selectedScreenSizes.includes('computer')">
                        <label for="computer">كمبيوتر</label>

                    </div>
                    <div class="checkbox-item">
                        <input aria-hidden="true" tabindex="-1"  type="checkbox" id="tablet" class="checkbox"
                            :checked="selectedScreenSizes.includes('tablet')">
                        <label for="tablet">تابلت</label>
                    </div>
                    <div class="checkbox-item">
                        <input aria-hidden="true" tabindex="-1"  type="checkbox" id="mobile" class="checkbox"
                            :checked="selectedScreenSizes.includes('mobile')">
                        <label for="mobile">جوال</label>

                    </div>
                </div>
            </div>

            <!-- Full Site Review Section -->
            <div class="section"
                :class="{ 'section-active': currentAnimationStep >= 6, 'section-scroll-in': currentAnimationStep === 6 }">
                <h3 class="section-title">هل تريد مراجعة لكل الموقع ؟</h3>
                <div class="yes-no-buttons" ref="yesNoButtonsContainer">
                    <button class="yes-no-btn" aria-hidden="true" tabindex="-1" :class="{ 'active': selectedReviewOption === 'yes' }" ref="yesButton">
                        نعم
                        <!-- Click Effect for Yes Button -->
                        <div class="button-click-effect" :class="{ 'active': showButtonClickEffect }">
                            <div class="click-circle circle-1"></div>
                            <div class="click-circle circle-2"></div>
                        </div>
                    </button>
                    <button aria-hidden="true" tabindex="-1" class="yes-no-btn">لا</button>
                </div>
            </div>

            <!-- Submit Button -->
            <div class="submit-section" ref="submitSectionContainer"
                :class="{ 'section-active': currentAnimationStep >= 7, 'section-scroll-in': currentAnimationStep === 7 }">
                <button  aria-hidden="true" tabindex="-1" class="submit-btn" ref="submitButton" :class="{ 'sent': isRequestSent }">
                    <span v-if="!isRequestSent">ارسال الطلب</span>
                    <span v-else class="sent-text">تم الإرسال بنجاح <svg width="24" height="24" viewBox="0 0 24 24"
                            fill="none" xmlns="http://www.w3.org/2000/svg" class="check-icon">
                            <circle cx="12" cy="12" r="12"  />
                            <path d="M9 12L11 14L15 10" stroke="white"  />
                        </svg> </span>
                    <!-- Click Effect for Submit Button -->
                    <div class="submit-click-effect" :class="{ 'active': showSubmitClickEffect }">
                        <div class="click-circle circle-1"></div>
                        <div class="click-circle circle-2"></div>
                    </div>
                </button>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed, watch } from 'vue'
const props = defineProps({
    startAnimitionShapeOne: {
        type: Boolean,
        required: true
    }
})
const startAnimationCycleRun = ref(false)

const startAnimitionShapeOne = computed(() => props.startAnimitionShapeOne)
watch(startAnimitionShapeOne, (newVal) => {
    if (newVal) {
        startAnimationCycle()
    } else {
        startAnimationCycleRun.value = false
    }
})
const finishLoading = ref(false)
const showFormAppear = ref(false)

// Reactive variables for typing effect
const displayText = ref('')
const isTyping = ref(false) // Cursor starts completely hidden
const targetText = 'akwad.sa'
const typingSpeed = 80 // milliseconds per character

// Click effect variables
const showClickEffect = ref(false)
const inputContainer = ref<HTMLElement>()

// Checkbox click effects
const showCheckboxClickEffects = ref(false)
const selectedCheckboxes = ref<string[]>([])

// Second slider animation variables
const secondSliderValue = ref(0)
const secondSliderFillWidth = ref(0)
const showSecondSliderAnimation = ref(false)
const showSecondSliderClickEffect = ref(false)
const secondSliderContainer = ref<HTMLElement>()

// Screen size click effect variables
const showScreenSizeClickEffect = ref(false)
const screenSizeContainer = ref<HTMLElement>()
const selectedScreenSizes = ref<string[]>([])

// Full site review variables
const selectedReviewOption = ref<'yes' | 'no'>('no')
const showButtonClickEffect = ref(false)
const yesNoButtonsContainer = ref<HTMLElement>()
const yesButton = ref<HTMLElement>()

// Submit button click effect variables
const showSubmitClickEffect = ref(false)
const submitSectionContainer = ref<HTMLElement>()
const submitButton = ref<HTMLElement>()

// Request sent status
const isRequestSent = ref(false)

// Animation step tracking for scroll effects
const currentAnimationStep = ref(0)
const formBox = ref<HTMLElement>()

// Complete animation cycle function (runs only once)
const startAnimationCycle = async () => {

    if (!startAnimitionShapeOne.value || startAnimationCycleRun.value) {
        return
    }

    await new Promise(resolve => setTimeout(resolve, 50))
    showFormAppear.value = true

    await new Promise(resolve => setTimeout(resolve, 500))


    startAnimationCycleRun.value = true
    // Step 1: Show click effect and keep cursor hidden
    currentAnimationStep.value = 1
    showClickEffect.value = true
    isTyping.value = false // Cursor remains hidden during click effect

    // Wait for click animation to complete (0.6s)
    await new Promise(resolve => setTimeout(resolve, 300))

    // Step 2: Hide click effect and show cursor for the first time
    showClickEffect.value = false
    isTyping.value = true // Show cursor ONLY after click effect is done

    // Wait a bit before starting typing (0.3s)
    await new Promise(resolve => setTimeout(resolve, 200))

    // Step 3: Start typing effect
    await typeText()

    // Step 4: Show checkbox click effects
    currentAnimationStep.value = 2
    scrollToSection(2)
    await new Promise(resolve => setTimeout(resolve, 500)) // Wait for scroll animation

    currentAnimationStep.value = 3
    scrollToSection(3)
    await showCheckboxClickEffectsSequence()

    // Step 5: Show second slider click effect and animation
    currentAnimationStep.value = 4
    scrollToSection(4)
    await new Promise(resolve => setTimeout(resolve, 500)) // Wait for scroll animation

    await showSecondSliderClickEffectAndAnimation()

    // Step 6: Show screen size click effect and select checkboxes
    currentAnimationStep.value = 5
    scrollToSection(5)
    await new Promise(resolve => setTimeout(resolve, 500)) // Wait for scroll animation

    await showScreenSizeClickEffectAndAnimation()

    // Step 7: Show button click effect and select review option
    currentAnimationStep.value = 6
    scrollToSection(6)
    await new Promise(resolve => setTimeout(resolve, 500)) // Wait for scroll animation

    await showButtonClickEffectAndAnimation()

    // Step 8: Show submit button click effect
    currentAnimationStep.value = 7
    scrollToSection(7)
    await new Promise(resolve => setTimeout(resolve, 500)) // Wait for scroll animation

    await showSubmitClickEffectAndAnimation()

    await new Promise(resolve => setTimeout(resolve, 500))
    showFormAppear.value = false
    // Step 9: Wait 2 seconds after animation completion
    await new Promise(resolve => setTimeout(resolve, 2000))

    // Step 10: Reset all elements to initial state
    await resetToInitialState()

    // Animation cycle is complete - no restart here
    startAnimationCycle()
}

// Typing effect function
const typeText = async () => {
    // Clear text first
    displayText.value = ''

    // Type the text character by character
    for (let i = 0; i <= targetText.length; i++) {
        displayText.value = targetText.slice(0, i)
        await new Promise(resolve => setTimeout(resolve, typingSpeed))
    }

    await new Promise(resolve => setTimeout(resolve, 500))
}

// Checkbox click effects sequence
const showCheckboxClickEffectsSequence = async () => {
    const checkboxes = ['ui-design', 'ux', 'accessibility', 'seo']

    for (let i = 0; i < checkboxes.length; i++) {
        // Add current checkbox to selected list (don't clear previous)
        selectedCheckboxes.value.push(checkboxes[i])
        showCheckboxClickEffects.value = true

        // Wait for click animation
        await new Promise(resolve => setTimeout(resolve, 200))

        // Hide click effect
        showCheckboxClickEffects.value = false

        // Wait before next checkbox
        await new Promise(resolve => setTimeout(resolve, 200))
    }

    // Keep all checkboxes selected in the end
    selectedCheckboxes.value = checkboxes
}

// Second slider click effect and animation sequence
const showSecondSliderClickEffectAndAnimation = async () => {
    // Step 1: Show click effect on slider
    showSecondSliderClickEffect.value = true

    // Wait for click animation to complete
    await new Promise(resolve => setTimeout(resolve, 300))

    // Step 2: Hide click effect
    showSecondSliderClickEffect.value = false

    // Step 3: Wait a bit before starting slider animation
    await new Promise(resolve => setTimeout(resolve, 100))

    // Step 4: Start slider animation
    showSecondSliderAnimation.value = true

    // Animate second slider from 0 to 6
    for (let i = 0; i <= 6; i++) {
        secondSliderValue.value = i
        secondSliderFillWidth.value = i * 10 // 10% per unit

        // Wait between each increment
        await new Promise(resolve => setTimeout(resolve, 50))
    }

    // Keep the final value
    secondSliderValue.value = 6
    secondSliderFillWidth.value = 60

    showSecondSliderAnimation.value = false
}

// Screen size click effect and animation sequence
const showScreenSizeClickEffectAndAnimation = async () => {
    // Step 1: Show click effect on screen size options
    showScreenSizeClickEffect.value = true

    // Wait for click animation to complete
    await new Promise(resolve => setTimeout(resolve, 300))

    // Step 2: Hide click effect and select checkboxes
    showScreenSizeClickEffect.value = false

    // Step 3: Select all screen size checkboxes
    selectedScreenSizes.value = ['tablet']
}

// Full site review click effect and animation sequence
const showButtonClickEffectAndAnimation = async () => {
    // Step 1: Show click effect on buttons
    showButtonClickEffect.value = true

    // Wait for click animation to complete
    await new Promise(resolve => setTimeout(resolve, 300))

    // Step 2: Hide click effect
    showButtonClickEffect.value = false

    // Step 3: Select the "نعم" button
    selectedReviewOption.value = 'yes'
}

// Submit button click effect and animation sequence
const showSubmitClickEffectAndAnimation = async () => {
    // Step 1: Show click effect on submit button
    showSubmitClickEffect.value = true

    // Wait for click animation to complete
    await new Promise(resolve => setTimeout(resolve, 300))

    // Step 2: Hide click effect
    showSubmitClickEffect.value = false

    // Set request sent status
    isRequestSent.value = true
}

// Function to scroll to specific section smoothly
const scrollToSection = (step: number) => {
    if (formBox.value) {
        const sections = formBox.value.querySelectorAll('.section')
        if (sections[step - 1]) {
            // Calculate the target scroll position within the form container
            const targetSection = sections[step - 1] as HTMLElement
            const containerRect = formBox.value.getBoundingClientRect()
            const sectionRect = targetSection.getBoundingClientRect()

            // Calculate the relative position within the container
            const relativeTop = sectionRect.top - containerRect.top
            const targetScrollTop = formBox.value.scrollTop + relativeTop - 20 // 20px offset for better positioning

            // Smooth scroll within the container only
            formBox.value.scrollTo({
                top: targetScrollTop,
                behavior: 'smooth'
            })
        }
    }
}

// Function to start the complete animation
const startAnimation = () => {
    startAnimationCycle()
}

// Function to reset all elements to initial state
const resetToInitialState = async () => {
    // Reset all reactive variables
    displayText.value = ''
    isTyping.value = false
    showClickEffect.value = false
    selectedCheckboxes.value = []
    secondSliderValue.value = 0
    secondSliderFillWidth.value = 0
    showSecondSliderAnimation.value = false
    showSecondSliderClickEffect.value = false
    selectedScreenSizes.value = []
    showScreenSizeClickEffect.value = false
    selectedReviewOption.value = 'no'
    showButtonClickEffect.value = false
    isRequestSent.value = false
    showSubmitClickEffect.value = false
    currentAnimationStep.value = 0

    // Reset form scroll position to top
    if (formBox.value) {
        formBox.value.scrollTop = 0
    }

    // Wait a bit for reset to complete
    await new Promise(resolve => setTimeout(resolve, 300))
}

// Start animation when component mounts
onMounted(() => {
    finishLoading.value = true

})

// Expose the animation function for external control
defineExpose({
    startAnimation,
    resetToInitialState
})
</script>

<style scoped>
/* ===== FIGMA FORM STYLES ===== */
/* Import IBM Plex Sans Arabic font */

/* Form Appear Animation */
.form-box {
    opacity: 0;
    transform: scale(0.8) translateY(50px);
    filter: blur(10px);
    transition: all .3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    border: 1px solid rgba(238, 238, 238, 0.933333);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.form-box.form-appear {
    opacity: 1;
    transform: scale(1) translateY(0);
    filter: blur(0);
}

/* Click Effect */
.click-effect {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    pointer-events: none;
    z-index: 10;
}

.click-circle {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 2px solid #b6b6b6;
    border-radius: 50%;
    opacity: 0;
}

.circle-1 {
    width: 20px;
    height: 20px;
}

.circle-2 {
    width: 20px;
    height: 20px;
}

.click-effect.active .circle-1 {
    animation: expand-circle-1 0.6s ease-out forwards;
}

.click-effect.active .circle-2 {
    animation: expand-circle-2 0.6s ease-out forwards;
}

@keyframes expand-circle-1 {
    0% {
        width: 20px;
        height: 20px;
        opacity: 1;
    }

    100% {
        width: 60px;
        height: 60px;
        opacity: 0;
    }
}

@keyframes expand-circle-2 {
    0% {
        width: 20px;
        height: 20px;
        opacity: 1;
    }

    50% {
        opacity: 1;
    }

    100% {
        width: 80px;
        height: 80px;
        opacity: 0;
    }
}

/* Main Form Box */
.form-box {
    width: 241px;
    height: 220px;
    background: #FFFFFF;
    border: 1px solid rgba(238, 238, 238, 0.933333);
    border-radius: 11.88px;
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 10px;
    overflow-y: auto;
    scroll-behavior: smooth;
    scroll-padding: 10px;
    -webkit-overflow-scrolling: touch;
}

.form-box::-webkit-scrollbar {
    display: none;
}

.form-box::-webkit-scrollbar-track {
    background: transparent;
}

.form-box::-webkit-scrollbar-thumb {
    background: rgba(88, 84, 255, 0.2);
    border-radius: 2px;
}

.form-box::-webkit-scrollbar-thumb:hover {
    background: rgba(88, 84, 255, 0.4);
}

/* Section Styles */
.section {
    display: flex;
    flex-direction: column;
    gap: 8px;
    opacity: 0.3;
    transform: translateY(20px);
    transition: all 0.3s ease-out;
}

.section-active {
    opacity: 1;
    transform: translateY(0);
}

.section-scroll-in {
    animation: scrollInAnimation 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
}

@keyframes scrollInAnimation {
    0% {
        opacity: 0.3;
        transform: translateY(20px);
    }

    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

.section-title {
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 18px;
    text-align: start;
    color: #000000;
    margin: 5px 0;
}

/* Input Container */
.input-container {
    position: relative;
    width: 206px;
    height: 27px;
    background: #FFFFFF;
    border: 1px solid rgba(238, 238, 238, 0.933333);
    border-radius: 8px;
    display: flex;
    align-items: center;
    padding: 3px 5px;
}

/* Typing Container */
.typing-container {
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    direction: rtl;
}

.typing-text {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 21px;
    color: #000000;
    min-height: 21px;
    display: flex;
    align-items: center;
}

.cursor {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 21px;
    color: #5854FF;
    margin-right: 2px;
    animation: blink 1s infinite;
}

.cursor.blink {
    animation: blink 1s infinite;
}

.cursor.hide {
    display: none;
}


@keyframes blink {

    0%,
    50% {
        opacity: 1;
    }

    51%,
    100% {
        opacity: 0;
    }
}

.website-input {
    direction: rtl;
    width: 100%;
    height: 100%;
    border: none;
    outline: none;
    background: transparent;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 21px;
    color: #BABABA;
}

.website-input::placeholder {
    color: #BABABA;
}

/* Second Slider Animation Effect */
.slider-fill.animate {
    transition: width 0.15s ease-out;
}

.slider-container .slider-value {
    transition: all 0.15s ease-out;
}

.slider-container .slider-value:not(:empty) {
    color: #5854FF;
    font-weight: 600;
}

/* Slider Container */
.slider-container {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 206px;
}

.slider-track {
    flex: 1;
    height: 1px;
    background: #D9D9D9;
    position: relative;
}

.slider-fill {
    height: 100%;
    background: #5854FF;
    position: absolute;
    top: 0;
    left: 0;
}

.slider-value {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    color: #000000;
    min-width: 15px;
}

/* Specialization Grid */
.specialization-grid {
    display: flex;
    gap: 9px;
    width: 206px;
}

.specialization-column {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.specialization-column:first-child {
    width: 150px;
}

.specialization-column:last-child {
    width: 117px;
}

/* Checkbox Items */
.checkbox-item {
    display: flex;
    align-items: center;
    gap: 8px;
    height: 18px;
}

.checkbox-item label {
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 18px;
    text-align: left;
    color: #000000;
    flex: 1;
}

.checkbox {
    width: 8px;
    height: 8px;
    border: 0.7px solid #000000;
    border-radius: 1px;
    appearance: none;
    cursor: pointer;
    flex-shrink: 0;
}

.checkbox:checked {
    background-color: #5854FF;
    border-color: #5854FF;
}

/* Checkbox Click Effect */
.checkbox-item {
    position: relative;
}

.checkbox-click-effect {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    pointer-events: none;
    z-index: 10;
}

.checkbox-click-effect .click-circle {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 2px solid #b6b6b6;
    border-radius: 50%;
    opacity: 0;
}

.checkbox-click-effect .circle-1 {
    width: 20px;
    height: 20px;
}

.checkbox-click-effect .circle-2 {
    width: 20px;
    height: 20px;
}

.checkbox-click-effect.active .circle-1 {
    animation: expand-circle-1 0.6s ease-out forwards;
}

.checkbox-click-effect.active .circle-2 {
    animation: expand-circle-2 0.6s ease-out forwards;
}

/* Screen Size Options */
.screen-size-options {
    display: flex;
    gap: 10px;
    justify-content: space-between;
}

.screen-size-options .checkbox-item {
    align-items: center;
    gap: 4px;
    height: auto;
}

.screen-size-options .checkbox-item label {
    text-align: center;
    font-size: 12px;
}

/* Yes/No Buttons */
.yes-no-buttons {
    display: flex;
    gap: 10px;
    justify-content: center;
    position: relative;
    /* Added for button click effect positioning */
}

.yes-no-btn {
    width: 32px;
    height: 28px;
    background: rgba(238, 238, 238, 0.933333);
    border: none;
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    color: #000000;
    cursor: pointer;
    transition: background-color 0.2s;
}

.yes-no-btn:hover {
    background: rgba(88, 84, 255, 0.1);
}

.yes-no-btn.active {
    background: #5854FF;
    color: white;
}

/* Button Click Effect */
.yes-no-btn {
    position: relative;
}

.button-click-effect {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    pointer-events: none;
    z-index: 10;
}

.button-click-effect .click-circle {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
        border: 2px solid #b6b6b6;
    border-radius: 50%;
    opacity: 0;
}

.button-click-effect .circle-1 {
    width: 20px;
    height: 20px;
}

.button-click-effect .circle-2 {
    width: 20px;
    height: 20px;
}

.button-click-effect.active .circle-1 {
    animation: expand-circle-1 0.6s ease-out forwards;
}

.button-click-effect.active .circle-2 {
    animation: expand-circle-2 0.6s ease-out forwards;
}

/* Submit Section */
.submit-section {
    margin-top: auto;
}

.submit-btn {
    width: 206px;
    height: 24px;
    background: #1A0F91;
    border: none;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    cursor: pointer;
    transition: background-color 0.2s;
    position: relative;
}

.submit-btn:hover {
    background: #2a1ba1;
}

.submit-btn span {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    color: #FFFFFF;
}

.submit-icon {
    width: 15px;
    height: 15px;
}

.submit-btn.sent {
    background: #4CAF50;
    /* Green background for success */
    color: white;
}

.submit-btn.sent .sent-text {
    font-weight: 600;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
}

.form-container {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}


/* Slider Click Effect */
.slider-container {
    position: relative;
}

.slider-click-effect {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    pointer-events: none;
    z-index: 10;
}

.slider-click-effect .click-circle {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 2px solid #b6b6b6;
    border-radius: 50%;
    opacity: 0;
}

.slider-click-effect .circle-1 {
    width: 20px;
    height: 20px;
}

.slider-click-effect .circle-2 {
    width: 20px;
    height: 20px;
}

.slider-click-effect.active .circle-1 {
    animation: expand-circle-1 0.6s ease-out forwards;
}

.slider-click-effect.active .circle-2 {
    animation: expand-circle-2 0.6s ease-out forwards;
}

/* Screen Size Click Effect */
.screen-size-options {
    position: relative;
}

.screen-click-effect {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    pointer-events: none;
    z-index: 10;
}

.screen-click-effect .click-circle {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 2px solid #b6b6b6;
    border-radius: 50%;
    opacity: 0;
}

.screen-click-effect .circle-1 {
    width: 20px;
    height: 20px;
}

.screen-click-effect .circle-2 {
    width: 20px;
    height: 20px;
}

.screen-click-effect.active .circle-1 {
    animation: expand-circle-1 0.6s ease-out forwards;
}

.screen-click-effect.active .circle-2 {
    animation: expand-circle-2 0.6s ease-out forwards;
}

/* Second Slider Animation Effect */
.slider-fill.animate {
    transition: width 0.15s ease-out;
}

/* Submit Button Click Effect */
.submit-click-effect {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    pointer-events: none;
    z-index: 10;
}

.submit-click-effect .click-circle {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 2px solid #b6b6b6;
    border-radius: 50%;
    opacity: 0;
}

.submit-click-effect .circle-1 {
    width: 20px;
    height: 20px;
}

.submit-click-effect .circle-2 {
    width: 20px;
    height: 20px;
}

.submit-click-effect.active .circle-1 {
    animation: expand-circle-1 0.6s ease-out forwards;
}

.submit-click-effect.active .circle-2 {
    animation: expand-circle-2 0.6s ease-out forwards;
}
</style>
